import {Component} from "@angular/core";
import AuthService from "../../services/auth.service";
import IUser from "../../interfaces/IUser";

@Component({
    selector: 'user',
    template: require('./user.component.html'),
    styles: [String(require('./user.styl'))],
})

export class UserComponent {

    private user: IUser;

    constructor(private authService: AuthService) {
        this.user = this.authService.user;
    }

    logout() {
        this.authService.logout();
    }


}



// WEBPACK FOOTER //
// ./src/app/components/user/user.component.ts